var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68425 1H19.7369C20.3473 1 20.8422 1.49484 20.8422 2.10526V20.8947C20.8422 21.5052 20.3473 22 19.7369 22H8.68425C8.07385 22 7.57901 21.5052 7.57898 20.8948H12V15.3685H7.57899V2.10526C7.57899 1.49484 8.07383 1 8.68425 1ZM11.8948 4.31578H12.1053C12.6576 4.31578 13.1053 4.7635 13.1053 5.31578V5.52631C13.1053 6.07859 12.6576 6.52631 12.1053 6.52631H11.8948C11.3425 6.52631 10.8948 6.07859 10.8948 5.52631V5.31578C10.8948 4.7635 11.3425 4.31578 11.8948 4.31578ZM15.3158 5.42105C15.3158 6.03147 15.8107 6.52631 16.4211 6.52631C17.0315 6.52631 17.5263 6.03147 17.5263 5.42105C17.5263 4.81063 17.0315 4.31578 16.4211 4.31578C15.8107 4.31578 15.3158 4.81063 15.3158 5.42105ZM12 10.3949C11.3896 10.3949 10.8948 9.90001 10.8948 9.28959C10.8948 8.67917 11.3896 8.18433 12 8.18433C12.6105 8.18433 13.1053 8.67917 13.1053 9.28959C13.1053 9.90001 12.6105 10.3949 12 10.3949ZM15.3158 9.28959C15.3158 9.90001 15.8107 10.3949 16.4211 10.3949C17.0315 10.3949 17.5263 9.90001 17.5263 9.28959C17.5263 8.67917 17.0315 8.18433 16.4211 8.18433C15.8107 8.18433 15.3158 8.67917 15.3158 9.28959ZM16.4211 14.2633C15.8107 14.2633 15.3158 13.7684 15.3158 13.158C15.3158 12.5476 15.8107 12.0527 16.4211 12.0527C17.0315 12.0527 17.5263 12.5476 17.5263 13.158C17.5263 13.7684 17.0315 14.2633 16.4211 14.2633ZM15.3158 17.0264C15.3158 17.6368 15.8107 18.1316 16.4211 18.1316C17.0315 18.1316 17.5263 17.6368 17.5263 17.0264C17.5263 16.4159 17.0315 15.9211 16.4211 15.9211C15.8107 15.9211 15.3158 16.4159 15.3158 17.0264Z",
    fill: "#959FA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92108 13.158H9.23687C10.1525 13.158 10.8948 13.6528 10.8948 14.2632V15.3684H6.47367V20.8947H10.8948V20.8948C10.8948 21.5052 10.1525 22.0001 9.23687 22.0001H5.92108C5.00545 22.0001 4.26318 21.5052 4.26318 20.8948V14.2632C4.26318 13.6528 5.00545 13.158 5.92108 13.158Z",
    fill: "#959FA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22H23",
    stroke: "#959FA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.2df229a7a2dd6a8f1597cf3be1fadf43.svg";
export { ForwardRef as ReactComponent };